module.exports = __webpack_public_path__ + "static/media/mbr-1920x1281.f989ea60.jpg";